import { useTranslation } from 'react-i18next';
import Reveal from './Reveal';

export default function CaseStudy({ number, title, organisation, situation, approach, result }) {
  const { t } = useTranslation('work');
  return (
    <Reveal>
      <article className="pt-16 md:pt-20">
        <p
          className="text-[11px] md:text-[12px] uppercase font-medium text-brand-accent"
          style={{ letterSpacing: '0.22em' }}
        >
          {t('caseLabel')} {number}
        </p>

        <h2 className="mt-5 font-display text-3xl md:text-[44px] font-semibold text-brand-primary leading-[1.1] tracking-tight max-w-3xl">
          {title}
        </h2>
        <p className="mt-3 text-sm text-brand-muted">{organisation}</p>

        <hr className="mt-10 border-black/10" />

        <div className="mt-10 space-y-12">
          <Section label={t('sectionLabels.situation')} text={situation} />
          <Section label={t('sectionLabels.approach')} text={approach} />

          <div
            className="bg-brand-surface border-l-2 border-brand-accent p-8 md:p-10 max-w-[72ch]"
            data-testid="case-study-result"
          >
            <p
              className="text-[11px] md:text-[12px] uppercase font-medium text-brand-accent mb-4"
              style={{ letterSpacing: '0.18em' }}
            >
              {t('sectionLabels.result')}
            </p>
            <p className="text-[17px] leading-[1.8] text-brand-text">{result}</p>
          </div>
        </div>
      </article>
    </Reveal>
  );
}

function Section({ label, text }) {
  return (
    <div className="max-w-[72ch]">
      <p
        className="text-[11px] md:text-[12px] uppercase font-medium text-brand-accent mb-4"
        style={{ letterSpacing: '0.18em' }}
      >
        {label}
      </p>
      <p className="text-[17px] leading-[1.8] text-brand-text">{text}</p>
    </div>
  );
}
